import {selectAppSetting} from "./select_app_setting.js";

export const selectIncludeArchived = (pane) => selectAppSetting(`${pane}.includeArchived`);
